import { AxiosInstance as AxiosServiceInstance } from "@careinfo/axios-service";
import { AxiosInstance } from "axios";
import { accessToken } from "./sessionKey";
import { ParseError } from "./ParseError";

let instance: AxiosInstance;

// Initialize the instance before making any API calls
const initInstance = async () => {
  if (!instance) {
    instance = await AxiosServiceInstance();
  }
};
// Get data from API
export const getApiData = async (url, param = null) => {
  await initInstance();
  let response: any;
  try {
    response = await instance({
      method: "GET",
      url: `${url}`,
      params: param,
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    return e.response;
  }
  return response;
};

// Post data to API
export const postApiData = async (data) => {
  const { url, formData, setError } = data;
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};

// Update data
export const patchApiData = async (data) => {
  const { url, formData, setError } = data;
  await initInstance();
  let response;
  try {
    response = await instance({
      method: "PATCH",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};
export const deleteApiData = async (data) => {
  const { url, setError } = data;
  await initInstance();
  let response;

  try {
    response = await instance({
      method: "DELETE",
      url: `${url}`,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },

      transformResponse: [
        function (responseData) {
          if (!responseData) return null; // 204 No Content
          return JSON.parse(responseData);
        },
      ],
      validateStatus: (status) => status >= 200 && status < 500, // allow custom handling
    });

    // If 204 No Content, return a specific value
    if (response.status === 204) {
      return { success: true, status: 204 };
    }
    return response;
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
};

export const patchApiFormData = async (data: any) => {
  const { url, formData, setError } = data;
  let response;
  await initInstance();
  try {
    response = await instance({
      method: "PATCH",
      url: `${url}`,
      data: formData,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      transformResponse: [
        function (responseData: any) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key) && setError) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};
export const postApiFormData = async (data: {
  url: string;
  formData: FormData;
  setError?: any;
}) => {
  await initInstance();
  const { url, formData, setError } = data;
  let response: any;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      transformResponse: [
        function (responseData: any) {
          try {
            return JSON.parse(responseData);
          } catch (e) {
            throw new ParseError(e.message);
          }
        },
      ],
    });
  } catch (e: any) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key) && setError) {
        setError(key as any, {
          type: "custom",
          message: e.response?.data[key],
        });
      }
    }
    return e.response;
  }

  return response;
};
